export default["__VITE_ASSET__BYtOZB5G__","__VITE_ASSET__BSp$rMAX__"];